import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@mantine/core";
import { useContext } from "react";
import { AppContext } from "../../shared/PrivateRoutes";
import { OrganizationFormContent } from "../organization/OrganizationFormContent";
export const SettingsOrganizationTab = ({ opened, onDirtyChange }) => {
    // Context
    const { organizationId } = useContext(AppContext);
    if (!organizationId)
        return null;
    return (_jsx(Box, { pt: "sm", children: _jsx(OrganizationFormContent, { organizationId: organizationId, allowEdit: true, active: opened, onDirtyChange: onDirtyChange }) }));
};
